import { Bolt } from 'components/lib/icons'
import useThemeColors from 'hooks/useThemeColors'
import { getOrgId } from 'modules/embed/utils'
import { pathOr } from 'ramda'
import React, { useMemo } from 'react'
import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'

import './style.css'

const Drift = () => {
  const { footerTextColor } = useThemeColors()

  const referrerUrl = pathOr('', ['context', 'page', 'hostname'], useSelector(state => state.session))

  const brandingUtmParameters = useMemo(() => {
    const orgId = getOrgId()
    if (orgId <= 1) {
      return ''
    }

    return `?utm_source=${referrerUrl}&utm_medium=web-widget&utm_campaign=widget-referral&utm_version=v2`
  }, [referrerUrl])

  return (
    <a
      href={`https://www.drift.com/powered-by${brandingUtmParameters}`}
      className="drift-widget-power"
      rel="noopener noreferrer"
      target="_blank"
      style={footerTextColor}
    >
      <Trans
        i18nKey="composer.footer.poweredByDrift"
        components={[
          <Bolt height={12} width={12} />,
          <span className="drift-widget-power-brand">Drift</span>
        ]}
      />
    </a>
  )
}

export default Drift
